// Widerrufsbutton: Sprache (EN Standard, DE bei deutschem Browser),
// Kunden-Tagging (contact[tags]) und optionaler Automation-Endpoint
// (markiert die Bestellung in Shopify und löst die native Kundenmail aus).
(function () {
  if (window.__bxbWiderrufInit) return;
  window.__bxbWiderrufInit = true;

  var isGerman = (navigator.language || '').toLowerCase().indexOf('de') === 0;

  function applyLanguage() {
    if (!isGerman) return;
    document.querySelectorAll('.bxb-i18n-en').forEach(function (el) { el.hidden = true; });
    document.querySelectorAll('.bxb-i18n-de').forEach(function (el) { el.hidden = false; });
  }

  function initForm() {
    var form = document.getElementById('WiderrufForm');
    if (!form) return;
    var wrapper = form.closest('[data-worker-url]');
    var workerUrl = wrapper ? (wrapper.getAttribute('data-worker-url') || '').trim() : '';

    form.addEventListener('submit', function () {
      var val = function (sel) { var el = form.querySelector(sel); return el ? el.value : ''; };

      var tags = form.querySelector('input[name="contact[tags]"]');
      var orderNo = val('[name="contact[Bestellnummer]"]');
      if (tags && orderNo) {
        var clean = orderNo.replace(/[^0-9A-Za-z#-]/g, '').slice(0, 30);
        if (clean) tags.value = 'widerruf-angefragt,widerruf-' + clean;
      }

      if (workerUrl) {
        try {
          fetch(workerUrl, {
            method: 'POST',
            mode: 'no-cors',
            keepalive: true,
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify({
              name: val('[name="contact[name]"]'),
              email: val('[name="contact[email]"]'),
              orderNumber: orderNo,
              message: val('[name="contact[body]"]')
            })
          });
        } catch (e) { /* Fallback: E-Mail an den Shop kommt trotzdem an */ }
      }
    });
  }

  function init() { applyLanguage(); initForm(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
